<ng-content select="kb-accordion-panel" />
